export default [
  {
    name: 'settlement',
    path: '/settlement',
    component: () => import('@/pages/settlement/Settlement.vue'),
  },
]
